import React from 'react'
import styled from 'styled-components'

import Image from '../../shared/image'
import Link from '../../shared/link'

import spotifyLogo from '../../../assets/images/spotify-logo.png'
import youtubeLogo from '../../../assets/images/youtube-logo.png'
import deezerLogo from '../../../assets/images/deezer-logo.png'
import soundcloudLogo from '../../../assets/images/soundcloud-logo.png'
import ampmeLogo from '../../../assets/images/ampme-logo.png'

const Logo = styled(Image)`
  width: ${props => props.width};
`

const MusicSourceLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const MusicSourceLogo = (props) => {
  let logo = ''
  let link = ''
  let ratio = '75'
  switch (props.source) {
  case 'spotify':
    logo = spotifyLogo
    link = 'https://www.spotify.com'
    break
  case 'youtube':
    logo = youtubeLogo
    link = 'https://www.youtube.com'
    break
  case 'deezer':
    logo = deezerLogo
    link = 'https://www.deezer.com'
    break
  case 'soundcloud':
    logo = soundcloudLogo
    link = 'https://www.soundcloud.com'
    ratio = '60'
    break
  default:
    logo = ampmeLogo
    link = 'https://www.ampme.com'
    ratio = '100'
    break
  }
  return (
    <div className={props.className}>
      <MusicSourceLink url={link}>
        <Logo src={logo} width={`${ratio}%`} />
      </MusicSourceLink>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/player/utils/musicSourceLogo.js